import { MultiScreenSession } from '../communication/MultiScreenSession';

export class MultiScreenBase {
    readonly sessions = new Map<MultiScreenSession['presentationId'], MultiScreenSession>();
    get hasSession() { return this.sessions.size; }

    protected _lastError?: unknown;
    get lastError() { return this._lastError; }

    protected _onSession: (session: MultiScreenSession) => void;
    protected _onMessage: (session: MultiScreenSession, message: string | Blob | ArrayLike<unknown>) => void;
    protected _onError: (e: unknown) => void;

    set onSession(callback: (session: MultiScreenSession) => void) {
        this._onSession = callback;
    }

    set onMessage(callback: (session: MultiScreenSession, message: string | Blob | ArrayLike<unknown>) => void) {
        this._onMessage = callback;
    }

    set onError(callback: (e: unknown) => void) {
        this._onError = callback;
    }

    constructor() {
        this._onSession = session => console.log('new connection', session);
        this._onMessage = (session, message) => console.log('message', session, message);
        this._onError = e => console.error(e);
    }

    async send(id: string, message: string | Blob | ArrayLike<unknown>) {
        const session = this.sessions.get(id);
        if (session) {
            await session.send(message);
        }
    }

    async sendAll(message: string | Blob | ArrayLike<unknown>) {
        return await Promise.all([...this.sessions.values()].map(session => session.send(message)));
    }

    protected setupSession(connection: PresentationConnection) {
        const session = new MultiScreenSession(connection, msg => {
            this._onMessage(session, msg);
        }, event => {
            this.sessions.delete(session.presentationId);
            console.log(`presentation connection closed due to ${event.reason}`, event.message);
        });
        this.sessions.set(session.presentationId, session);
        this._onSession(session);
    }
}
